module.exports = __webpack_public_path__ + "media/images/banner/banner_merger_for_kufu_sp-21c588802621167bfdbed1c8a56e7b50.png";